const getTranslation = (language, page, company, text) => {
  const texts = require(`./${language}.json`)
  return texts[company][page][text]
}

export default getTranslation
